import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import MachineMockup from "./MachineMockup";

export default function Hero() {
  const { user } = useAuth();
  const ctaTo = user ? "/app/machines/new" : "/solicitar-acceso";

  return (
    <section className="relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20 pt-16 sm:pt-24 lg:pt-28 pb-20 lg:pb-28">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          <div>
            <motion.p
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="text-xs uppercase tracking-widest font-medium text-zinc-500 mb-6"
            >
              Pasaporte digital para máquinas industriales
            </motion.p>
            <motion.h1
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.55, delay: 0.08 }}
              className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-zinc-950 leading-[1.08]"
              data-testid="hero-headline"
            >
              La identidad digital de cada máquina.
            </motion.h1>
            <motion.p
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.55, delay: 0.16 }}
              className="text-lg sm:text-xl text-zinc-600 max-w-xl leading-relaxed mt-6"
            >
              Toda la información, documentación e historial de tus equipos industriales.
              Organizada, actualizada y accesible desde cualquier lugar.
            </motion.p>
            <motion.div
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.55, delay: 0.24 }}
              className="flex flex-wrap items-center gap-4 mt-9"
            >
              <Link
                to={ctaTo}
                data-testid="hero-primary-cta"
                className="inline-flex items-center px-7 py-3.5 rounded-full bg-zinc-900 text-white font-medium hover:bg-zinc-800 hover:scale-[1.02] active:scale-95 transition-[background-color,transform] duration-200"
              >
                {user ? "Crear mi primera máquina" : "Probar Asset Passport"}
              </Link>
              <a
                href="#como-funciona"
                data-testid="hero-secondary-cta"
                className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-white border border-zinc-200 font-medium text-zinc-700 hover:border-zinc-300 hover:scale-[1.02] active:scale-95 transition-[border-color,transform] duration-200"
              >
                Ver cómo funciona <ArrowDown size={15} />
              </a>
            </motion.div>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 24, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="relative"
          >
            <div className="absolute -inset-8 bg-zinc-100/60 rounded-[2.5rem] -z-10" />
            <MachineMockup />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
